/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Title_AccentInputs */

const en_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A better way to swing.`)
};

const es_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una mejor forma de hacer swing.`)
};

const de_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine bessere Art zu schwingen.`)
};

const zh_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更好的挥杆方式。`)
};

const ar_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طريقة أفضل للسوينغ.`)
};

const fr_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une meilleure façon de swinguer.`)
};

const vi_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một cách swing tốt hơn.`)
};

const sw_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Njia bora ya kufanya swing.`)
};

const th_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิธีที่ดีกว่าในการสวิง`)
};

const bs_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolji način zamaha.`)
};

const ja_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`より良いスイングへの道。`)
};

const ko_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 나은 스윙 방법.`)
};

const pt_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma melhor maneira de fazer o swing.`)
};

const it_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un modo migliore per fare swing.`)
};

const sv_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ett bättre sätt att svinga.`)
};

const nl_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een betere manier om te swingen.`)
};

const da_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En bedre måde at svinge på.`)
};

const nb_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En bedre måte å svinge på.`)
};

const fi_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parempi tapa swingata.`)
};

const pl_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lepszy sposób na swing.`)
};

const ru_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лучший способ делать свинг.`)
};

const tr_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sving için daha iyi bir yol.`)
};

const hi_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्विंग का बेहतर तरीका।`)
};

const id_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara yang lebih baik untuk mengayun.`)
};

const ms_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara yang lebih baik untuk menghayun.`)
};

const cs_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lepší způsob, jak švihnout.`)
};

const el_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ένας καλύτερος τρόπος για σβινγκ.`)
};

const he_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דרך טובה יותר לסווינג.`)
};

const af_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'n Beter manier om te swaai.`)
};

const hu_method_title_accent = /** @type {(inputs: Method_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egy jobb mód a lendítésre.`)
};

/**
* | output |
* | --- |
* | "A better way to swing." |
*
* @param {Method_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_title_accent = /** @type {((inputs?: Method_Title_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Title_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_title_accent(inputs)
	if (locale === "de") return de_method_title_accent(inputs)
	if (locale === "zh") return zh_method_title_accent(inputs)
	if (locale === "ar") return ar_method_title_accent(inputs)
	if (locale === "fr") return fr_method_title_accent(inputs)
	if (locale === "vi") return vi_method_title_accent(inputs)
	if (locale === "sw") return sw_method_title_accent(inputs)
	if (locale === "th") return th_method_title_accent(inputs)
	if (locale === "bs") return bs_method_title_accent(inputs)
	if (locale === "ja") return ja_method_title_accent(inputs)
	if (locale === "ko") return ko_method_title_accent(inputs)
	if (locale === "pt") return pt_method_title_accent(inputs)
	if (locale === "it") return it_method_title_accent(inputs)
	if (locale === "sv") return sv_method_title_accent(inputs)
	if (locale === "nl") return nl_method_title_accent(inputs)
	if (locale === "da") return da_method_title_accent(inputs)
	if (locale === "nb") return nb_method_title_accent(inputs)
	if (locale === "fi") return fi_method_title_accent(inputs)
	if (locale === "pl") return pl_method_title_accent(inputs)
	if (locale === "ru") return ru_method_title_accent(inputs)
	if (locale === "tr") return tr_method_title_accent(inputs)
	if (locale === "hi") return hi_method_title_accent(inputs)
	if (locale === "id") return id_method_title_accent(inputs)
	if (locale === "ms") return ms_method_title_accent(inputs)
	if (locale === "cs") return cs_method_title_accent(inputs)
	if (locale === "el") return el_method_title_accent(inputs)
	if (locale === "he") return he_method_title_accent(inputs)
	if (locale === "af") return af_method_title_accent(inputs)
	if (locale === "hu") return hu_method_title_accent(inputs)
	return en_method_title_accent(inputs)
});